import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "root-list" };
import { computed } from 'vue';
import { tableHeaders } from '@/constants/listControl';
import OrderItem from '@/views/ListControl/OrderItem.vue';
import vuexStore from '@/vuex-store';
import { modalWorkerInfoActionType } from '@/vuex-store/modal-worker-info/actions';
import { listControlGetterType } from '@/vuex-store/list-control/getters';
import { listControlActionType } from '@/vuex-store/list-control/actions';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderList',
    setup(__props) {
        const getterMainOrderList = computed(() => vuexStore.getters[listControlGetterType.getterMainOrderList]);
        const sortBy = computed(() => vuexStore.state.listControl.sortBy);
        const openModal = (orderId) => {
            vuexStore.dispatch('modalOrderInfo/setIsOpenModalOrderInfo', orderId);
        };
        const openWorkerModal = (workerCode) => {
            vuexStore.dispatch(modalWorkerInfoActionType.setIsOpenModalWorkerInfo, workerCode);
        };
        /**
         * 정렬 업데이트 핸들러
         */
        const handleUpdateSortBy = (sortData) => {
            vuexStore.dispatch(listControlActionType.setSortBy, sortData);
        };
        return (_ctx, _cache) => {
            const _component_v_data_table_virtual = _resolveComponent("v-data-table-virtual");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_data_table_virtual, {
                    hover: "",
                    "data-cy": "order-list",
                    class: "sort-th-adjustment brg-table brg-table-v-line list-control-data-table",
                    "fixed-header": "",
                    density: "compact",
                    "item-height": "40",
                    headers: _unref(tableHeaders),
                    items: getterMainOrderList.value,
                    "sort-by": sortBy.value,
                    "onUpdate:sortBy": handleUpdateSortBy
                }, {
                    item: _withCtx(({ item }) => [
                        (_openBlock(), _createBlock(OrderItem, {
                            key: item.orderId,
                            "order-item": item,
                            "open-order-modal": openModal,
                            "open-worker-modal": openWorkerModal
                        }, null, 8 /* PROPS */, ["order-item"]))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["headers", "items", "sort-by"])
            ]));
        };
    }
});
